// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.mp-page-grid {
    display: grid;
    grid-template-areas: 
        "top top" 
        "middle right";
    grid-template-rows: 80px auto;  /* Header + Content */
    grid-template-columns: 250px auto 250px 250px; /* Sidebar - Main - Right Sidebar */
    display: flex;
    flex-direction: column;
    height: auto;
    max-height: 1000vh;
    width: 1200px;
    gap: 15px;
    place-items: center;
    border-radius: 20px;

  }

  .mp-page-grid-upper {
    /* margin-left: 40px; */
    min-height: 180px;
    height: auto;
    width: 100%;
    box-shadow:  1px 1px 3px 0px white;
    border-radius: 20px;
  }
  
  .mp-page-grid-lower {
    background: none;
    width: 100%;
    max-width: 1250px;
    min-width: 1000px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 10px;
    margin-top: -20px;
    overflow-y: auto;
    z-index: 1000;
    height: 1600px;
    max-height: 1000vh;
  }

    /* Responsive Design */
    @media (max-width: 900px) {
        .page-grid {
          grid-template-areas:
            "top"
            "middle"
            "left"
            "right";
          grid-template-columns: 1fr;
          grid-template-rows: 80px auto auto auto;
        }
      }
      `, "",{"version":3,"sources":["webpack://./src/components/Pages/OverlayPage/Styles/MemberProfilePage.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb;;sBAEkB;IAClB,6BAA6B,GAAG,qBAAqB;IACrD,6CAA6C,EAAE,mCAAmC;IAElF,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;;EAErB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAEhB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;;IAEE,sBAAsB;IACtB;QACI;UACE;;;;mBAIS;UACT,0BAA0B;UAC1B,uCAAuC;QACzC;MACF","sourcesContent":["\n.mp-page-grid {\n    display: grid;\n    grid-template-areas: \n        \"top top\" \n        \"middle right\";\n    grid-template-rows: 80px auto;  /* Header + Content */\n    grid-template-columns: 250px auto 250px 250px; /* Sidebar - Main - Right Sidebar */\n    max-height: 1000vh;\n    display: flex;\n    flex-direction: column;\n    height: auto;\n    max-height: 1000vh;\n    width: 1200px;\n    gap: 15px;\n    place-items: center;\n    border-radius: 20px;\n\n  }\n\n  .mp-page-grid-upper {\n    /* margin-left: 40px; */\n    min-height: 180px;\n    height: auto;\n    width: 100%;\n    box-shadow:  1px 1px 3px 0px white;\n    border-radius: 20px;\n  }\n  \n  .mp-page-grid-lower {\n    background: none;\n    max-height: 1000vh;\n    width: 100%;\n    max-width: 1250px;\n    min-width: 1000px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    padding: 10px;\n    margin-top: -20px;\n    overflow-y: auto;\n    z-index: 1000;\n    height: 1600px;\n    max-height: 1000vh;\n  }\n\n    /* Responsive Design */\n    @media (max-width: 900px) {\n        .page-grid {\n          grid-template-areas:\n            \"top\"\n            \"middle\"\n            \"left\"\n            \"right\";\n          grid-template-columns: 1fr;\n          grid-template-rows: 80px auto auto auto;\n        }\n      }\n      "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
